export default [
    {
        path: '/locations',
        component : () => import('../../views/locations/locations.vue'),
    },
    {
        path: '/locationsOutside',
        component : () => import('../../views/locations/locationsOutside.vue'),
    },
    {
        path: '/roomDoor',
        component: () => import('../../views/roomDoor/roomDoor'),
    },
];